// extracted by mini-css-extract-plugin
export var modal = "_cu-0";